<template>

  <main id="page_vitrine" role="main" class="bg-light">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>


    <div class="position-relative bg-primary overflow-hidden">
      <div class="container position-relative z-index-2 space-bottom-1">

        <div class="text-justify mx-md-auto">
          <div class="mb-7">

            <div class="row justify-content-center mt-5">
              <div class="col-12 col-md-6 mb-3 mb-md-0 d-inline-block">
                <h3 class="text-center text-white text-capitalize">{{aap.projet_nom}}</h3>
                <br>
                <div class="d-flex justify-content-center">
                  <img class="img-fluid h-100 rounded mx-auto my-auto" style="object-fit: cover; max-height: 250px" :src="aap.projet_illustration" alt="image de présentation">
                </div>
                <br>
                <h3 class="text-center text-white">{{aap.nom}}</h3>
              </div>

              <div class="my-auto" style="max-width: 50%">
                <a class="btn btn-white btn-block text-primary font-weight-bold mb-2" style="font-size: 1.125rem" href="#" role="button">
                  <i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>Retour aux projets
                </a>

                <div class="card px-5 py-3">
                  <div class="d-inline-flex my-3 pl-4">
                    <i class="fa fa-calendar h2 text-primary mr-3"></i>
                    <div class="align-self-center pl-2">
                      <p class="h4 text-primary mb-1">Date de début</p>
                      <p class="h5 mb-0 text-muted">{{aap.date_debut}}</p>
                    </div>
                  </div>
                  <br>
                  <div class="d-inline-flex my-3 pl-4">
                    <i class="fa fa-list h2 text-primary mr-3"></i>
                    <div class="align-self-center pl-2">
                      <p class="h4 text-primary mb-1">Axe : {{ aap.axe }}</p>
                      <ul class="h5 mb-0 text-muted read_more" style="text-align: start">
                        <li v-for="tag in aap.tags">{{ tag.nom }}</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <a class="btn btn-white btn-block text-primary font-weight-bold mt-2" style="font-size: 1.125rem" href="#" role="button">
                  <i class="fa fa-comments mr-2" aria-hidden="true"></i>Contacter la structure
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Nav Classic -->
        <ul class="nav nav-segment nav-fill" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="presentation-tab" data-toggle="pill" href="#presentation" role="tab"
               aria-controls="presentation" aria-selected="true" @mouseup="checkForReadMore('presentation')">
              <div class="d-md-flex justify-content-md-center align-items-md-center">
                <i class="fas fa-info-circle mr-2"></i>Présentation
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="project-manager-tab" data-toggle="pill" href="#project-manager" role="tab"
               aria-controls="project-manager" aria-selected="false" @mouseup="checkForReadMore('project-manager')">
              <div class="d-md-flex justify-content-md-center align-items-md-center">
                <i class="fa fa-user mr-2"></i>Porteur du projet
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="realisation-tab" data-toggle="pill" href="#realisation" role="tab"
               aria-controls="realisation" aria-selected="false" @mouseup="checkForReadMore('realisation')">
              <div class="d-md-flex justify-content-md-center align-items-md-center">
                <i class="fa fa-cubes mr-2"></i>Activités
              </div>
            </a>
          </li>
          <li class="nav-item"
              v-if="aap.benevoles || aap.besoins_materiels || aap.besoins_locaux ||   aap.besoins_expertise || aap.besoins_financement">
            <a class="nav-link" id="participate-tab" data-toggle="pill" href="#participate" role="tab"
               aria-controls="participate" aria-selected="false" @mouseup="checkForReadMore('participate')"
               @click="showSticky = true">
              <div class="d-md-flex justify-content-md-center align-items-md-center">
                <i class="fa fa-thumbs-up mr-2"></i>Participation
              </div>
            </a>
          </li>
          <!--                <li class="nav-item">-->
          <!--                    <a class="nav-link" id="calendar-tab" data-toggle="pill" href="#calendar" role="tab"-->
          <!--                       aria-controls="calendar" aria-selected="false" @mouseup="checkForReadMore('calendar')">-->
          <!--                        <div class="d-md-flex justify-content-md-center align-items-md-center">-->
          <!--                            <i class="fa fa-star mr-2"></i>Calendrier-->
          <!--                        </div>-->
          <!--                    </a>-->
          <!--                </li>-->
        </ul>
      </div>
    </div>
    <!-- Property Description Section -->
    <div class="container">
      <div class="mb-9 mb-lg-0">
        <div class="tab-content">

          <div class="tab-pane mt-6 show active" id="presentation" role="tabpanel" aria-labelledby="presentation-tab">

            <!-- View Info -->
            <div class="border-bottom py-4 mt-4 mb-1">
              <div class="row justify-content-center w-60 mx-auto">
                <div class="border-primary border-3 rounded space-1">
                  <h2 class="mb-4 text-center text-primary">Présentation du projet</h2>
                  <p class="h4 text-muted text-justify font-weight-normal position-relative mb-0 read_more"
                     @mouseenter="showEdit($event)" @mouseleave="hideEdit($event)">
                    {{aap.presentation}}
                    <img class="gear" @mouseup="editText($event)"
                         src="/themes/template/img/gear.png"
                         style="display: none; position: absolute; top: -16px; right: -16px; height: 32px; width: 32px">
                  </p>
                  <!--                                <a class="h4 text-secondary read_more_button" href="javascript:;"-->
                  <!--                                   data-readmore="less" @click="clickReadMore($event)"></a>-->
                </div>
              </div>
            </div>
            <!-- End View Info -->

            <!-- View Info -->
            <div class="row justify-content-lg-between align-items-lg-center space-top-1 border-bottom mb-5">
              <div class="col-lg-7 order-lg-2 space-1">
                <h2 class="mb-4 text-primary">Les origines du projet</h2>
                <p class="h4 text-muted font-weight-normal read_more mb-0">
                  {{aap.origine}}
                </p>
              </div>

              <div class="col-lg-4 order-lg-1 mb-5">
                <div class="bg-img-hero-center h-100 min-h-270rem rounded-lg"
                     :style="{backgroundImage:backRandomImage('origines', 8)}"></div>
              </div>
            </div>
            <!-- End View Info -->

            <!-- Features Section -->
            <div class="container text-center">
              <div class="card space-1">
                <div class="mb-5 mt-3">
                  <h2 class="text-primary">Objectif</h2>
                </div>

                <div class="d-flex align-items-center justify-content-center mb-3">
                  <div class="avatar avatar-lg mr-2">
                    <img class="avatar-img" src="/modules/dlnkaap/img/target.png" alt="Image Description">
                  </div>
                  <div class="w-65">
                    <p class="text-center h4 text-primary my-2">{{aap.projet_objectif}}</p>
                  </div>
                  <div class="avatar avatar-lg ml-2">
                    <img class="avatar-img" src="/modules/dlnkaap/img/target.png" alt="Image Description">
                  </div>
                </div>
              </div>

              <div class="row py-5">
                <!-- Card Block -->
                <div class="col-6 col-lg-4 mt-1 mb-3 align-self-stretch" v-for="objectif in aap.objectifs">
                  <div class="card flex-wrap flex-row">
                    <div class="card-body py-6">
                      <h3 class="mb-5">{{objectif.objectif}}</h3>
                      <figure class="max-w-27rem w-100 mx-auto mb-4">
                        <img class="img-fluid" :src="getGoalImage(objectif.id)" alt="Image Description" style="max-height:100px">
                      </figure>
                      <p class="h5 text-muted font-weight-normal read_more mb-0">{{objectif.description}}</p>
                    </div>
                  </div>
                </div>
                <!-- End Card Block -->
              </div>
            </div>
            <!-- End Features Section -->
            <!-- End Row -->
          </div>

          <div class="tab-pane mt-6" id="project-manager" role="tabpanel" aria-labelledby="project-manager-tab">

            <!-- Testimonials Section -->
            <div class="overflow-hidden container space-1">
              <h2 class="text-center text-primary mb-10">Porteur du projet</h2>
              <div class="row justify-content-lg-around align-items-md-center">
                <div class="col-md-3 order-md-2 mb-11 mb-md-0">
                  <div class="position-relative">
                    <img class="img-fluid rounded-lg" src="/modules/dlnkaap/img/shadow.jpg" alt="Photo du porteur de projet">

                    <!-- SVG Elements -->
                    <figure class="max-w-19rem w-100 position-absolute top-0 left-0 z-index-n1">
                      <div class="mt-n7 ml-n7">
                        <img class="img-fluid" src="/themes/template/img/components/dots-2.svg" alt="Image Description">
                      </div>
                    </figure>
                    <figure class="max-w-19rem w-100 position-absolute bottom-0 right-0 z-index-n1">
                      <div class="mb-n7 mr-n7">
                        <img class="img-fluid" src="/themes/template/img/components/dots-2.svg" alt="Image Description">
                      </div>
                    </figure>
                    <!-- End SVG Elements -->
                  </div>
                </div>

                <div class="col-md-8 col-lg-7 order-md-1 text-center">
                  <div class="card bg-soft-primary p-3">
                    <div class="row align-items-center justify-content-center">
                      <div class="col-5">
                        <h2 class="text-primary">{{aap.candidat_nom}}</h2>
                        <h3 class="">{{aap.candidat_fonction}}</h3>
                        <h3 class="">{{aap.candidat_service}}</h3>
                        <span class="d-block h4 mb-1">
                                                <i class="fas fa-phone mr-1"></i>
                                                {{aap.candidat_telephone}}
                                            </span>
                        <a class="h4">{{aap.candidat_email}}</a>
                      </div>
                      <!--                                     CHANGER LE V-IF UNE FOIS LE CHAMP AJOUTE-->
                      <div v-if="false" class="col-7">
                        <figure class="mb-3">
                          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="36" height="36" viewBox="0 0 8 8">
                            <path fill="#377DFF" d="M3,1.3C2,1.7,1.2,2.7,1.2,3.6c0,0.2,0,0.4,0.1,0.5c0.2-0.2,0.5-0.3,0.9-0.3c0.8,0,1.5,0.6,1.5,1.5c0,0.9-0.7,1.5-1.5,1.5
                                                    C1.4,6.9,1,6.6,0.7,6.1C0.4,5.6,0.3,4.9,0.3,4.5c0-1.6,0.8-2.9,2.5-3.7L3,1.3z M7.1,1.3c-1,0.4-1.8,1.4-1.8,2.3
                                                    c0,0.2,0,0.4,0.1,0.5c0.2-0.2,0.5-0.3,0.9-0.3c0.8,0,1.5,0.6,1.5,1.5c0,0.9-0.7,1.5-1.5,1.5c-0.7,0-1.1-0.3-1.4-0.8
                                                    C4.4,5.6,4.4,4.9,4.4,4.5c0-1.6,0.8-2.9,2.5-3.7L7.1,1.3z"/>
                          </svg>
                        </figure>
                        <div class="">
                          <blockquote class="h3 font-weight-normal mb-4">Lorem ipsum dolor sit amet,
                            consectetur adipiscing elit. Aenean sollicitudin lectus tortor, id consequat
                            mi venenatis elementum. </blockquote>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Testimonials Section -->

          </div>

          <div class="tab-pane mt-6" id="realisation" role="tabpanel" aria-labelledby="realisation-tab">

            <!-- Features Section -->
            <div class="overflow-hidden">
              <div class="container">
<!--                <div class="row justify-content-center w-75 mx-auto">-->

<!--                  <div class="mb-5">-->
<!--                    <h1 class="text-primary">Les étapes du projet</h1>-->
<!--                  </div>-->

<!--                  &lt;!&ndash; Icon Block &ndash;&gt;-->
<!--                  <ul class="step step-dashed mb-3">-->
<!--                    <li class="step-item mb-3" v-for="etape in aap.etapes" :key="etape.id">-->
<!--                      <div class="step-content-wrapper">-->
<!--                        <span class="step-icon step-icon-xs step-icon-soft-primary">1</span>-->
<!--                        <div class="step-content">-->
<!--                          <h4>{{etape.etape}}</h4>-->
<!--                          <p class="h5 font-italic">{{etape.date_french}}</p>-->
<!--                          <p class="mb-0 read_more">{{ etape.description }}</p>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </li>-->
<!--                  </ul>-->
<!--                  &lt;!&ndash; End Icon Block &ndash;&gt;-->
<!--                </div>-->

                <!-- Articles Section -->
                <div class="container space-top-1 ">
                  <!-- Title -->
                  <div class="w-md-80 w-lg-50 text-center mx-md-auto mb-5 mb-md-9">
                    <h2 class="h1 text-primary">Activités prévues</h2>
                    <p>Les actions concrètes dans le cadre du projet</p>
                    <a class="btn btn-primary" href="/module/dlnkcalendar/events?event_type_id=6" role="button" style="font-size: 1.2rem">
                      <i class="fa fa-paper-plane mr-2" aria-hidden="true"></i>Poster vos activités
                    </a>
                  </div>
                  <!-- End Title -->

                  <div class="row mx-n2 space-bottom-1">
                    <div class="col-sm-6 col-lg-4 px-2 mb-3" v-for="activite in aap.activites" :key="activite.id">
                      <!-- Card -->
                      <a class="card h-100 transition-3d-hover" href="#">
                        <img class="card-img-top" :src="pseudoRandomImage('activities',6, activite.id)"
                             alt="Image Description">
                        <div class="card-body">
                          <span class="d-block small font-weight-bold text-cap mb-2">{{activite.activite}}</span>
                          <h5 class="mb-0 read_more">{{activite.description}}</h5>
                        </div>

<!--            ----------TODO : A AJOUTER PLUS TARD--------------         -->
<!--                        <div class="card-footer py-2 px-3">-->
<!--                          <div class="d-flex justify-content-between align-items-center">-->
<!--                            <a class="btn btn-primary" href="#" role="button">Je participe !</a>-->
<!--                            <div class="">-->
<!--                              <a class="btn text-primary px-1" href="#" role="button" title="J'aime !" style="background-color: transparent !important;">-->
<!--                                <i class="fa fa-thumbs-up fa-2x" aria-hidden="true"></i>-->
<!--                              </a>-->
<!--                              <a class="btn text-primary px-1" href="#" role="button" title="Partager" style="background-color: transparent !important;">-->
<!--                                <i class="fa fa-share fa-2x" aria-hidden="true"></i>-->
<!--                              </a>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
                      </a>
                      <!-- End Card -->
                    </div>
                  </div>
                </div>
                <!-- End Articles Section -->
              </div>
            </div>
            <!-- End Features Section -->
          </div>

          <div class="tab-pane mt-6" id="participate" role="tabpanel" aria-labelledby="participate-tab">

            <div class="row">
              <!-- Features Section -->
              <div class="col-lg-8">
                <!-- Title -->
                <div class="text-center mx-auto mb-3">
                  <h2 class="text-primary">Appel à participation</h2>
                </div>
                <!-- End Title -->

                <!-- Nav -->
                <div class="text-center">
                  <ul class="nav nav-segment nav-pills scrollbar-horizontal mb-7" role="tablist">
                    <li class="nav-item" v-if="aap.benevoles">
                      <a class="nav-link active" id="pills-benevoles-tab" data-toggle="pill" href="#pills-benevoles"
                         role="tab" aria-controls="pills-benevoles" aria-selected="true">
                        <i class="fa fa-users mr-2" aria-hidden="true"></i>Bénévoles</a>
                    </li>
                    <li>
                      <!--<a class="nav-link" id="pills-two-code-features-tab" data-toggle="pill" href="#pills-two-code-features"
                        role="tab" aria-controls="pills-two-code-features" aria-selected="false">Personnel</a>
                      </li>-->
                    <li class="nav-item" v-if="aap.besoins_materiels">
                      <a class="nav-link" v-bind:class="!aap.benevoles ? 'active' : ''" id="pills-materiel-tab" data-toggle="pill" href="#pills-materiel"
                         role="tab" aria-controls="pills-materiel" aria-selected="false">
                        <i class="fa fa-wrench mr-2" aria-hidden="true"></i>Matériel</a>
                    </li>
                    <li class="nav-item" v-if="aap.besoins_locaux">
                      <a class="nav-link" v-bind:class="!aap.benevoles && !aap.besoins_materiels ? 'active':''" id="pills-locaux-tab" data-toggle="pill" href="#pills-locaux"
                         role="tab" aria-controls="pills-locaux" aria-selected="false">
                        <i class="fa fa-building mr-2" aria-hidden="true"></i>Locaux</a>
                    </li>
                    <!--<li class="nav-item">
                        <a class="nav-link" id="pills-five-code-features-tab" data-toggle="pill" href="#pills-five-code-features"
                          role="tab" aria-controls="pills-five-code-features" aria-selected="false">Autres</a>
                    </li>-->
                  </ul>
                </div>
                <!-- End Nav -->

                <!-- Tab Content -->
                <div class="tab-content">
                  <div v-if="aap.benevoles" class="tab-pane fade show active" id="pills-benevoles" role="tabpanel" aria-labelledby="pills-benevoles-tab">
                    <div class="col justify-content-center">
                      <div class="col-12 mb-3" v-for="(benevole, index) in aap.benevoles_projet">
                        <!-- Icon Blocks -->
                        <div class="media">
                          <figure class="w-100 max-w-8rem mr-4">
                            <img class="img-fluid" src="/themes/template/img/checked.png" alt="SVG">
                          </figure>
                          <div class="media-body">
                            <h3>Mission #{{ index + 1 }}</h3>
                            <p class="font-italic" style="font-size: 1rem">Nombre de bénévoles sollicités : <span class="font-italic text-muted">{{ benevole.nombre }}</span></p>
                            <p style="font-size: 1rem">{{ benevole.mission }}</p>
                          </div>
                        </div>
                        <!-- End Icon Blocks -->
                      </div>
<!--                      <h3 v-if="aap.benevoles_projet.length === 0" class="text-center">Nous cherchons des bénévoles !</h3>-->
                      <h3 v-if="aap.benevoles_projet.length === 0" class="text-center">Nous cherchons des bénévoles !</h3>
                    </div>
                  </div>

                  <div class="tab-pane fade" id="pills-materiel" role="tabpanel" aria-labelledby="pills-materiel-tab">
                    <div class="col-10 mb-0">
                      <div class="mb-4">
                        <h2>Nos besoins en matériel</h2>
                        <p style="font-size: 1rem">{{aap.materiels}}</p>
                      </div>
                    </div>
                  </div>

                  <div class="tab-pane fade" id="pills-locaux" role="tabpanel" aria-labelledby="pills-locaux-tab">
                    <div class="col-10 mb-0">
                      <div class="mb-4">
                        <h2>Nos besoins en locaux</h2>
                        <p style="font-size: 1rem">{{aap.locaux}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End Tab Content -->
              </div>
              <!-- End Features Section -->

              <div id="stickyBlockStartPoint" class="col col-lg-4">
                <!-- Contact Form -->
                <div v-if="showSticky" class="js-sticky-block card card-bordered"
                     data-hs-sticky-block-options='{
                        "parentSelector": "#stickyBlockStartPoint",
                        "breakpoint": "lg",
                        "startPoint": "#stickyBlockStartPoint",
                        "endPoint": "#stickyBlockEndPoint",
                        "stickyOffsetTop": 40,
                        "stickyOffsetBottom": 0
                      }'>

                  <div class="card-body">
                    <div class="mx-auto">
                      <!-- Header -->
                      <div class="media align-items-center mb-4">
                        <div class="avatar avatar-circle mr-3">
                          <img class="avatar-img" src="/themes/template/img/100x100/img8.jpg" alt="image de profil">
                        </div>
                        <div class="media-body">
                          <h4 class="mb-0">Proposez votre aide aux porteurs !</h4>
                        </div>
                      </div>
                      <!-- End Header -->

                      <!-- Form -->
                      <form>
                        <select class="custom-select custom-select-sm mb-2">
                          <option value="offerVolunteer" selected>Vous souhaitez participer en tant que bénévole</option>
                          <option value="offerTools">Vous souhaitez proposer du matériel</option>
                          <option value="offerTransport">Vous souhaitez aider pour le transport</option>
                          <option value="offerPremises">Vous souhaitez proposer des locaux</option>
                          <option value="offerTalent">Vous souhaitez proposer une expertise</option>
                        </select>

                        <div class="mb-2">
                          <label class="sr-only" for="firstName">Prénom</label>
                          <input type="text" class="form-control form-control-sm" name="text" id="firstName" placeholder="Prénom" aria-label="Prénom">
                        </div>

                        <div class="mb-2">
                          <label class="sr-only" for="lastName">Nom</label>
                          <input type="text" class="form-control form-control-sm" name="text" id="lastName" placeholder="Nom" aria-label="Nom">
                        </div>

                        <div class="mb-2">
                          <label class="sr-only" for="email">Email</label>
                          <input type="email" class="form-control form-control-sm" name="text" id="email" placeholder="Email" aria-label="Email">
                        </div>

                        <div class="mb-2">
                          <label class="sr-only" for="phoneNumber">Numéro de téléphone</label>
                          <input type="tel" class="form-control form-control-sm" name="tel" id="phoneNumber" placeholder="Numéro de téléphone" aria-label="Numéro de téléphone">
                        </div>

                        <div class="mb-2">
                          <label class="sr-only" for="clarification">Précisions</label>
                          <textarea class="form-control form-control-sm" rows="4" name="answer" id="clarification" placeholder="Vous pouvez apporter des précisions." aria-label="Vous pouvez apporter des précisions."></textarea>
                        </div>

                        <button type="button" class="btn btn-block btn-primary btn-wide transition-3d-hover" href="#">Participer</button>
                      </form>
                      <!-- End Form -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sticky Block End Point -->
            <div id="stickyBlockEndPoint"></div>

          </div>

          <div class="tab-pane mt-6" id="calendar" role="tabpanel" aria-labelledby="calendar-tab">

            <!-- Testimonials Section -->
            <div class="overflow-hidden container space-1">
              <h2 class="text-center mb-10">Calendrier</h2>
              <div class="d-flex w-100 justify-content-center">
                <img src="/themes/template/img/aap/calendar.png" class="img-fluid">
              </div>
            </div>
            <!-- End Testimonials Section -->

          </div>
        </div>

      </div>
      <!-- End Tab Content -->
      <hr class="mt-6">
    </div>
  </main>
</template>



<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  props: ['aap_id'],
  data: function () {
    return {
      message: "",
      message_type: "",
      hidden_element: null,
      is_editing: false,
      readMore_max_lines: 5,
      readMoreButton: "<a class='text-secondary font-weight-bold read_more_button' href='javascript:;' data-readmore='less'></a>",
      showSticky: false,

      customer: Object,
      aap: Object,
      logo_structure: String,
      photo_porteur: String,
      projet_illustration: String,



      editor: ClassicEditor,
      editor_config: {
        toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo' ],
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }
          ]
        }
      },
    }
  },
  mounted() {
    this.logo_structure = "/modules/dlnkaap/img/socialmedia.jpg"
    this.photo_porteur = "/modules/dlnkaap/img/socialmedia.jpg"
    this.projet_illustration = "/modules/dlnkaap/img/socialmedia.jpg"
    this.get_data()
    this.checkForReadMore(this.getActiveTabId())
  },

  updated() {
    this.checkForReadMore(this.getActiveTabId());
  },

  destroyed() {
    removeEditingEvent();
  },

  computed: {},

  watch: {
  },

  methods: {

    removeEditingEvent: function(){
      document.removeEventListener("click", this.isEditingField);
    },

    close_message: function () {
      this.message = null;
    },

    add_view: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += `aaps/${_this.aap_id}/views.json`
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.patch(api_url)
          .then(function (response) {
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_data: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += `aaps/${_this.aap_id}.json`
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.aap = response.data.aap

            _this.add_view()

            if (typeof(response.data.logo_structure) != 'undefined' ) {
              _this.logo_structure = response.data.logo_structure
            }

            if (typeof(response.data.photo_porteur) != 'undefined' ) {
              _this.photo_porteur = response.data.photo_porteur
            }

          })
          .catch(function (error) {
            console.log(error)
          })
          .then(

          );

    },

    showEdit: function(event){
      //event.target.querySelector(".gear").style.display = "block";
    },

    hideEdit: function(event){
      // event.target.querySelector(".gear").style.display = "none";
    },

    editText: function(event){
      if(this.is_editing)
      {
        _this.message = "Vous êtes déjà en train de mettre à jour un champ. Ce dernier a été validé."
        _this.message_type = "alert-warning";
        return;
      }
      this.is_editing = true;

      let textToEdit = event.target.parentNode;

      let textArea = document.createElement("textarea");
      textArea.id = "editing-field";
      textArea.style.resize = "none";
      textArea.style.width = (textToEdit.clientWidth + 12).toString()+"px";
      textArea.style.height = (textToEdit.clientHeight + 12).toString()+"px";
      textArea.style.fontSize = window.getComputedStyle(textToEdit).fontSize;
      textArea.value = textToEdit.innerText;

      this.hidden_element = textToEdit;
      textToEdit.style.display = "none";
      textToEdit.parentNode.appendChild(textArea);
      document.addEventListener("mousedown", this.isEditingField);
    },

    isEditingField: function(event){
      var textArea = document.getElementById('editing-field');
      if (!textArea.contains(event.target)) {
        //On a cliqué en dehors du textarea
        textArea.remove();
        this.hidden_element.style.display = "block";
        this.removeEditingEvent();
        this.is_editing = false;
      }
    },

    asyncCheck: async function(targetId){
      setTimeout(this.checkForReadMore_Delayed,100, targetId);
    },

    checkForReadMore: function(targetId){
      setTimeout(this.checkForReadMore_Delayed,100, targetId);
    },

    checkForReadMore_Delayed: function(targetId){
      let tab = document.getElementById(targetId);
      let readMoreElems = Array.from(tab.getElementsByClassName("read_more"));
      for(let element of readMoreElems)
      {
        let button = element.parentNode.querySelector('.read_more_button');
        if(button && (button.innerText !== "" || element.style.height === "auto"))
        {
          //Le contenu a déjà un readmore
          continue;
        }

        //Limite le nombre de lignes à readMore_max_lines
        element.style.height = (this.extractNb(window.getComputedStyle(element).getPropertyValue("line-height"))
            * this.readMore_max_lines).toString() + "px";

        if(this.isOverflown(element))
        {
          //On clone l'élément de texte pour conserver le style
          let clone = element.cloneNode(true);
          clone.classList.remove("read_more");
          clone.style.height = "auto";
          clone.innerText = "";
          element.after(clone);

          //On rajoute le bouton "Voir plus"
          clone.insertAdjacentHTML('beforeend', this.readMoreButton);
          clone.lastChild.innerText = "Voir plus ...";

          clone.lastChild.addEventListener("click", this.clickReadMore);
        }
        else {
          element.style.height = "auto";
        }
      }
    },

    isOverflown: function(element){
      return element.scrollHeight > element.clientHeight;
    },

    clickReadMore: function(event){
      let target = event.target;
      if(target.getAttribute("data-readmore") === "less")
      {
        this.showMore(target);
        target.setAttribute("data-readmore", "more")
      }
      else
      {
        this.showLess(target);
        target.setAttribute("data-readmore", "less")
      }
    },

    showLess: function(button){
      button.innerText = "Voir plus ...";
      let text = button.parentNode.parentNode.querySelector('.read_more');
      text.style.height = (this.extractNb(window.getComputedStyle(text).getPropertyValue("line-height"))
          * this.readMore_max_lines).toString() + "px";
      text.style.overflow = "hidden";
    },

    showMore: function(button){
      button.innerText = "Voir moins";
      let text = button.parentNode.parentNode.querySelector('.read_more');
      text.style.height = text.scrollHeight + "px";
    },

    extractNb: function(str){
      return parseFloat(str.match(/[+-]?\d+(\.\d+)?/g)[0]);
    },

    backRandomImage: function(type_image, maximum) {
      let random = 1 + (this.aap.id % maximum);
      return 'url(/modules/dlnkaap/img/' + type_image + '/' + random.toString() +'.jpg)';
    },

    pseudoRandomImage: function(type_image, maximum, id) {
      let random = 1 + (id % maximum);
      return '/modules/dlnkaap/img/' + type_image + '/' + random.toString() +'.jpg';
    },

    getGoalImage: function(goal_id){
      return '/modules/dlnkaap/img/goals/goal' + (1 + goal_id % 6).toString() + '.svg';
    },

    getActiveTabId: function(){
      return document.querySelector(".tab-pane.active").id;
    },
  }
}
</script>

<style>
</style>